
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { ProductPlanModel } from 'models/generated/Entities.GormCrm.ProductPlan';
import { OrderLineModel } from 'models/generated/Entities.GormCrm.OrderLine';
import { ProductPlanTagModel } from 'models/generated/Entities.GormCrm.ProductPlanTag';
import { PlanReplacementModel } from 'models/generated/Entities.GormCrm.PlanReplacement';
import { FreeProductPlanSettingDtoModel } from 'models/generated/Models.FreeProductPlanSettingDto';
import { ProductPlanSettingModel } from 'models/generated/Entities.GormCrm.ProductPlanSetting';


const _gormCrm_ProductPlanControllerHelper = new Map<string, Object>();
_gormCrm_ProductPlanControllerHelper.set('GetAllProductPlans', ProductPlanModel);
_gormCrm_ProductPlanControllerHelper.set('GetProductPlanOrderLines', OrderLineModel);
_gormCrm_ProductPlanControllerHelper.set('GetProductPlansByOrder', ProductPlanModel);
_gormCrm_ProductPlanControllerHelper.set('GetProductPlans', ProductPlanModel);
_gormCrm_ProductPlanControllerHelper.set('SearchProductPlans', ProductPlanModel);
_gormCrm_ProductPlanControllerHelper.set('GetProductPlansByCompanyId', ProductPlanModel);
_gormCrm_ProductPlanControllerHelper.set('GetProductPlanTags', ProductPlanTagModel);
_gormCrm_ProductPlanControllerHelper.set('GetPlanReplacementsByCompany', PlanReplacementModel);
_gormCrm_ProductPlanControllerHelper.set('CreateProductPlan', ProductPlanModel);
_gormCrm_ProductPlanControllerHelper.set('CreateProductPlanFromProductVariantId', ProductPlanModel);
_gormCrm_ProductPlanControllerHelper.set('GetFreeProductPlanSettingByTag', FreeProductPlanSettingDtoModel);
_gormCrm_ProductPlanControllerHelper.set('ProductPlanSettings', ProductPlanSettingModel);


export const gormCrm_ProductPlanControllerHelper = _gormCrm_ProductPlanControllerHelper;

